import Component from '../app/component.js'
import sessionDocuments from '../plugins/session-documents.js'
import events from '../plugins/events.js'

export default class extends Component {
  constructor (el) {
    super(el)
    this.data = {
      documentsCount: 0
    }
  }

  init () {
    document.addEventListener('sessionDocuments.update', e => {
      this.data.documentsCount = (e.detail?.documents?.length) ? e.detail.documents.length : 0;
      this.refs.list.classList.add('top-list--animate');
      setTimeout(() => {
        this.refs.list.classList.remove('top-list--animate');
      }, 1000);
    })

    this.data.documentsCount = sessionDocuments.get().length
    
    this.refs.list.addEventListener('click', () => {
      events.emit('requestoverlay.toggle')
    })

    events.on('requestoverlay.display', () => {
      this.refs.list.classList.add(this.refs.list.dataset.closeClass)
      this.refs.listLabel.textContent = this.refs.listLabel.dataset.closeLabel
    })

    events.on('requestoverlay.hidden', () => {
      this.refs.list.classList.remove(this.refs.list.dataset.closeClass)
      this.refs.listLabel.textContent = this.refs.listLabel.dataset.defaultLabel
    })
  }

  watchDocumentsCount (value) {
    if (value < 1) {
      this.refs.documentsCount.classList.remove('top-list-counter--active');
    } else {
      this.refs.documentsCount.classList.add('top-list-counter--active');
    }
    this.refs.documentsCount.textContent = typeof value === 'number' ? value : 0
  }
}
